import React from 'react';
import { AppState } from '../../../redux/reducers';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';
import { AzureFileOwner } from '../../../models/Entities/AzureFiles/AzureFileUpload';
import { getSettlementStorageOwner } from '../SettlementtHeader/SettlementHeader.Functions';

export interface SettlementInvoiceUploadRenderProps {
  /** Opens the upload drawer (no preselected files) */
  openUpload: () => void;
  /** Already translated reason why the upload is not available, undefined when enabled */
  disabledReason: string | undefined;
}

interface IProps {
  SettlementId: number;
  children: (upload: SettlementInvoiceUploadRenderProps) => React.ReactNode;
}

interface ConnectedProps {
  owner: AzureFileOwner | undefined;
  isSettlementLoaded: boolean;
}

export type Props = IProps & ConnectedProps;

export const mapStateToProps = (state: AppState, ownProps: IProps): ConnectedProps => {
  const settlement: Settlement | undefined = state.Settlement?.list?.find(
    (item: Settlement) => item.id === ownProps.SettlementId
  );
  return {
    owner: getSettlementStorageOwner(settlement),
    isSettlementLoaded: !!settlement,
  };
};
